import info from '@assets/icons/info.svg';
import PlaceholderPicture from '@assets/images/placeholder.png';
import { TaCard } from '@components/shared/TaCard/TaCard';
import CustomTooltip from '@components/tooltip/tooltip';
import useClipboard from '@hooks/useClipboard';
import useLanguageNavigate from '@hooks/useLanguageNavigate';
import { useTruncate } from '@hooks/useTruncate';
import { useWindowSize } from '@hooks/useWindowSize';
import CheckIcon from '@mui/icons-material/Check';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { CardMedia, Tooltip } from '@mui/material';
import IconButton from '@mui/material/IconButton/IconButton';
import { useTranslation } from 'react-i18next';

export function ProfileCode({ profile }: any) {
	const size = useWindowSize();
	const { copied, copyToClipboard } = useClipboard();
	const { navigateWithLanguage } = useLanguageNavigate();

	const { truncate } = useTruncate();
	const { t } = useTranslation();

	const profilePicture = profile?.profile_picture ? profile?.profile_picture : PlaceholderPicture;
	const fullName = `${profile?.first_name || ''} ${profile?.last_name || ''}`;

	const handleClick = () => {
		navigateWithLanguage('/specialist/profile');
	};

	return (
		<TaCard className="h-full">
			<div className="flex w-full flex-row gap-5 pb-5">
				<CardMedia
					component="img"
					image={profilePicture}
					alt={profile?.first_name}
					sx={{ width: 103, height: 103, borderRadius: '12px', objectFit: 'cover' }}
				/>
				<div className="flex flex-col justify-between">
					<Tooltip title={fullName} arrow>
						<span
							className="text-primary underline font-bold text-xl leading-[28px] cursor-pointer"
							onClick={handleClick}
						>
							{truncate(fullName, 13)}
						</span>
					</Tooltip>
					{/* <div className="flex flex-col">
						<Rating readOnly name="simple-controlled" value={0} />
					</div>
					<div className="flex justify-between items-center w-full">
						<div className="flex flex-col items-start justify-center">
							<span className="text-light-grey underline font-normal text-base mb-2 lowercase cursor-pointer">
								0 {t('reviews')}
							</span>
						</div>
					</div> */}
				</div>
			</div>
			<div className="flex justify-between items-center border-t border-light pt-5">
				<div>
					<div className="flex mb-[10px] items-center gap-[5px]">
						<span className="text-secondary font-normal text-base">{t('myCode')}</span>
						<CustomTooltip
							marginLeftArrow
							placement="top"
							sx={{ marginLeft: size.width <= 1400 ? '10px !important' : '16px !important' }}
							title={
								<div className="flex w-full gap-[10px]">
									<img className="pointer" src={info} alt="info" />
									<p className="roboto-regular text-[16px] leading-[140%]">
										{t('farmersRequests')}
									</p>
								</div>
							}
						>
							<IconButton className="!p-0 !m-0 !bg-transparent">
								<img className="cursor-pointer" src={info} alt="info" />
							</IconButton>
						</CustomTooltip>
					</div>
					<div className="text-dark font-medium text-lg">
						{truncate(profile?.connection_code, 12)}
					</div>
				</div>
				<IconButton
					className="!w-11 !h-11 !bg-[#F0F2F4] !rounded-lg"
					onClick={() => copyToClipboard(profile?.connection_code)}
				>
					{copied ? (
						<CheckIcon className="fade-in" sx={{ color: '#00AB89' }} />
					) : (
						<ContentCopyIcon />
					)}
				</IconButton>
			</div>
		</TaCard>
	);
}
